import { useQuery } from "convex/react";
import { api } from "$convex/convexApi";
import { useAuthIdentity } from "@/contexts/UserProfileContext";

export function useAccessorials() {
  return useQuery(api.accessorials.listAccessorials, {});
}

export function useLogisticsCarriers() {
  const { authUserId } = useAuthIdentity();
  return useQuery(
    api.logistics.getCarriers,
    authUserId ? { authUserId } : "skip",
  );
}

export function useCarriersWithBlockStatus(userId?: string) {
  const { authUserId } = useAuthIdentity();
  return useQuery(
    api.logistics.getCarriersWithBlockStatus,
    authUserId && userId ? { authUserId, userId: userId as any } : "skip",
  );
}

export function useUserPreferences(userId?: string) {
  const { authUserId } = useAuthIdentity();
  return useQuery(
    api.logistics.getUserPreferences,
    authUserId && userId ? { authUserId, userId: userId as any } : "skip",
  );
}
